import { IAffiliatePageLang } from '../../../types/lang'

export const affiliatePageLang: IAffiliatePageLang = {
	affiliate_page: {
		//btn_add_new: 'Add New_ua',
	}
}